import {
  Checkbox,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  ListItem as MuiListItem,
} from "@mui/material";

import { Prettify } from "types";

interface Props {
  checked?: boolean;
  disabled?: boolean;
  primary: React.ReactNode;
  onClick: () => void;
  secondary?: React.ReactNode;
}

export const ListItem = ({
  checked,
  onClick,
  primary,
  secondary,
  disabled = false,
}: Prettify<Props>) => {
  return (
    <MuiListItem disablePadding>
      <ListItemButton
        dense
        role={undefined}
        onClick={onClick}
        disabled={disabled}
        alignItems="flex-start"
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            tabIndex={-1}
            disableRipple
            checked={checked}
          />
        </ListItemIcon>

        <ListItemText primary={primary} secondary={secondary} />
      </ListItemButton>
    </MuiListItem>
  );
};
